import DuplicateLineButton from '../../../../elements/DuplicateLineButton'
import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const {
    list,
    fetch,
    fetching,
    isUpdatable,
    tableRef,
    onShow,
    selection,
    setSelection,
    selectAll,
    toggleSelection,
    toggleAll,
    isSelected,
  } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    { Header: 'Price', accessor: 'price', Cell: MoneyCell },
    { Header: 'Tax Value', accessor: 'tax.rate', Cell: MoneyCell },
    { Header: 'UOM', accessor: 'uom.name' },
  ]
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <>
          <Button
            disabled={!isUpdatable}
            type={'primary'}
            size="small"
            icon={'plus'}
            onClick={onShow}>
            New
          </Button>
          <DuplicateLineButton
            selection={selection || !isUpdatable}
            fetch={fetch}
            setSelection={setSelection}
            disabled={selection.length === 0}
          />
        </>
      )}
      defaultSorted={[
        {
          id: 'name',
          desc: false,
        },
      ]}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
